import React from "react";
import Context from "../../../Context";
import CartButton from "../../Misc/Cart/CartButton";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import MaintPicker from "../../Misc/MaintPicker";
import Scrollpane from "../../Misc/Scrollpane";
import ElementAllOperation from "./ElementAllOperation";
import ElementCatalog from "./ElementCatalog";
import ElementDetail from "./ElementDetail";
import ElementShipSelect from "./ElementShipSelect";
import ElementTreeList from "./ElementTreeList";
export default class Element extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      customListKey: "",
      rights: {},
      maintPickShow: false,
      operaionShow: false,
      clonePending: false,
    };
  }

  componentDidMount() {
    this.assignRights();
  }

  componentDidUpdate() {
    this.renderButtons();
  }

  assignRights = () => {
    this.setState(
      {
        rights: {
          manageModel: true,
          manageElement: true,
          manageSpec: true,
          manageSpare: true,
          manageMeasure: true,
          manageMaint: true,
        },
      },
      () => this.renderButtons()
    );
  };

  clone = async (elementId) => {
    this.setState({ clonePending: true });
    let result = await this.context.api.q("/element/clone", {
      source: elementId,
    });
    this.setState({ clonePending: false });
    if (result?.destination) {
      const { shipId, specId } = this.props;
      this.onAfterElementSave();
      this.context.redirect(
        `/element/${shipId}/${specId}/${result.destination}`
      );
      this.context.toast("Оборудование скопировано", "success");
    } else {
      this.context.toast("Не удалось скопировать оборудование", "error");
    }
  };

  onAfterElementSave = () => {
    this.setState({ customListKey: this.context.key() });
  };

  renderButtons = () => {
    const { shipId, specId, elementId } = this.props;

    let showAddButton = this.state.rights.manageElement;
    if (shipId === "any" && specId === "any") {
      showAddButton = false;
    }

    let editUrl = `/element/${shipId}/${specId}/add`;
    if (elementId) {
      editUrl = `/element/${shipId}/${specId}/add?parent=${elementId}`;
    }

    this.context.actionsSet(
      <>
        {showAddButton && (
          <>
            <div
              onClick={() => this.context.redirect(editUrl)}
              title="Добавить оборудование"
              className={`btn btn-icon ${
                this.state.mode === "add" ? "btn-light-primary" : "btn-light"
              }  mr-2`}
            >
              <span className="flaticon2-add-1 "></span>
            </div>
            {elementId && (
              <div
                onClick={() => this.clone(elementId)}
                title="Клонировать оборудование"
                className={`btn btn-icon btn-light mr-2 ${
                  this.state.clonePending && "disabled"
                }`}
              >
                {this.state.clonePending && <div className="spinner"></div>}
                <span className="flaticon2-add-1 "></span>
                <i className="fa fa-copy"></i>
              </div>
            )}
          </>
        )}
        {shipId && shipId !== "any" && (
          <div
            onClick={this.onOperationOpen}
            title="Внесение наработки"
            className={`btn btn-icon btn-light mr-2`}
          >
            <i className="fa fa-clock-o"></i>
          </div>
        )}
        <CartButton context={this.context} />
      </>
    );
  };

  onMaintPickOpen = (callback) => {
    this.setState({ maintPickShow: true, maintPickCallback: callback });
  };

  onMaintPickClose = () => {
    this.setState({ maintPickShow: false });
  };

  onOperationOpen = () => {
    this.setState({ operaionShow: true });
  };

  onOperationClose = () => {
    this.setState({ operaionShow: false });
  };

  render() {
    return (
      <>
        <ElementAllOperation
          show={this.state.operaionShow}
          onClose={this.onOperationClose}
          {...this.props}
        />

        <MaintPicker
          onPick={this.state.maintPickCallback}
          onClose={this.onMaintPickClose}
          show={this.state.maintPickShow}
          {...this.props}
          {...this.state.rights}
        />
        <CrumbsProvider title="Структура СТСиК" link="/element/" />
        <div className="row h-100">
          <div className="col-lg-3 border-right no-print">
            <Scrollpane>
              <ElementShipSelect {...this.props} {...this.state.rights} />
              <ElementCatalog {...this.props} {...this.state.rights} />
            </Scrollpane>
          </div>
          <div className="col-lg-4 border-right no-print">
            <Scrollpane>
              <ElementTreeList
                {...this.props}
                customListKey={this.state.customListKey}
              />
            </Scrollpane>
          </div>
          <div className="col h-100">
            <Scrollpane>
              {this.props.elementId && (
                <ElementDetail
                  {...this.props}
                  {...this.state.rights}
                  onAfterSave={this.onAfterElementSave}
                  onMaintPickOpen={this.onMaintPickOpen}
                />
              )}
            </Scrollpane>
          </div>
        </div>
      </>
    );
  }
}
